import {Injectable} from '@angular/core';
import {WindowService} from '../window/window.service';
import {CustomDimensionMap, GA4BaseEvent} from '../../models/google-analytics.model';

@Injectable()
export class GoogleAnalyticsService {
  static readonly customDimensions: CustomDimensionMap = {};

  static setCustomDimension(key: string, value: string): void {
    if (value) {
      GoogleAnalyticsService.customDimensions[key] = value;
    }
  }

  static sendEvent(data: GA4BaseEvent): void {
    const event = {
      ...data,
      ...GoogleAnalyticsService.customDimensions,
    };

    WindowService.window.dataLayer.push(event);
  }
}
